module.exports = __webpack_public_path__ + "vendors/modernizr.js"


/*****************
 ** WEBPACK FOOTER
 ** ./src/vendors/modernizr.js
 ** module id = 607
 ** module chunks = 0
 **/